import React, { useState } from 'react';
import styled from 'styled-components';
import { database } from './firebase';
import { ref, push, set } from 'firebase/database';
import { useNavigate } from 'react-router-dom';

import BackButton from './components/BackButton';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto 2rem auto;
  padding: 1rem;
`;

const Title = styled.h2`
  font-size: 2rem;
  margin-bottom: 1rem;
  color: #333;
  text-align: center;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: white;
  padding: 2rem 1rem;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
  margin-top: 1rem;
`;

const Input = styled.input`
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 1rem;
`;

const TextArea = styled.textarea`
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 1rem;
  min-height: 100px;
`;

const Button = styled.button`
  padding: 0.75rem;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  margin-top: 1rem;

  &:hover {
    background: #0056b3;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

const SuccessMessage = styled.div`
  background: #d4edda;
  color: #155724;
  padding: 1rem;
  border-radius: 5px;
  margin-top: 1rem;
  text-align: center;
`;

const ErrorMessage = styled.div`
  background: #f8d7da;
  color: #721c24;
  padding: 1rem;
  border-radius: 5px;
  margin-top: 1rem;
  text-align: center;
`;


const NewMemberPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    description: '',
    technicalSkills: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  // const handleBack = () => {
  //   navigate('/');
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    setSuccess(false);

    try {
      // Validate email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        throw new Error('Please enter a valid email address');
      }

      // Validate phone number (basic validation)
      const phoneRegex = /^[0-9+\-\s()]{10,}$/;
      if (!phoneRegex.test(formData.phone)) {
        throw new Error('Please enter a valid phone number');
      }

      // Split and trim technical skills
      const skillsList = formData.technicalSkills
        .split(',')
        .map(skill => skill.trim())
        .filter(skill => skill.length > 0);

      // Save to database
      const applicationsRef = ref(database, 'new-member-application');
      const newApplicationRef = push(applicationsRef);
      await set(newApplicationRef, {
        fullName: formData.fullName,
        email: formData.email,
        phone: formData.phone,
        description: formData.description,
        technicalSkills: skillsList,
        createdAt: new Date().toISOString(),
        status: 'pending'
      });

      // Reset form and show success message
      setFormData({
        fullName: '',
        email: '',
        phone: '',
        description: '',
        technicalSkills: ''
      });
      setSuccess(true);
    } catch (error) {
      console.error('Error submitting application:', error);
      setError(error.message || 'Failed to submit application. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container>
      
      
      <Form onSubmit={handleSubmit}>
      <Title>Join Our Team</Title>
        <Input
          type="text"
          name="fullName"
          placeholder="Full Name"
          value={formData.fullName}
          onChange={handleChange}
          required
        />
        <Input
          type="email"
          name="email"
          placeholder="Email Address"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <Input
          type="tel"
          name="phone"
          placeholder="Phone Number"
          value={formData.phone}
          onChange={handleChange}
          required
        />
        <TextArea
          name="description"
          placeholder="Tell us about yourself and why you want to join our team"
          value={formData.description}
          onChange={handleChange}
          required
        />
        <Input
          type="text"
          name="technicalSkills"
          placeholder="Technical Skills (comma separated)"
          value={formData.technicalSkills}
          onChange={handleChange}
          required
        />
        <Button type="submit" disabled={submitting}>
          {submitting ? 'Submitting...' : 'Submit Application'}
        </Button>
        {success && <SuccessMessage>Application submitted successfully! We'll get back to you soon.</SuccessMessage>}
        {error && <ErrorMessage>{error}</ErrorMessage>}
      </Form>
      <BackButton/>
    </Container>
  );
};

export default NewMemberPage;
